import { IconId } from '@components/icons/id';
import { IconTextFormatLink } from '@components/icons/text-format-link';
import { FieldMappingFieldItem } from '@components/text-editors/addons/field-mapping';

export type JourneyDataLabelKey =
  | 'travellerUrl'
  | 'travellerId'
  | 'createdByName'
  | 'createdByEmail'
  | 'createdAt'
  | 'triggeredByName'
  | 'triggeredByEmail'
  | 'currentDate'
  | 'startedAt'
  | 'sourceType';

export type JourneyDataTranslate = (key: JourneyDataLabelKey) => string;

export const getJourneyDataFields = (t: JourneyDataTranslate): FieldMappingFieldItem[] => {
  return [
    {
      label: t('travellerUrl'),
      source: 'journey_data',
      field: 'url',
      type: 'text',
      icon: <IconTextFormatLink size={16} color="elementPurple80" />,
    },
    {
      label: t('travellerId'),
      source: 'journey_data',
      field: 'id',
      type: 'text',
      icon: <IconId size={16} color="elementPurple80" />,
    },
    { label: t('createdByName'), source: 'journey_data', field: 'created_by_name', type: 'text' },
    {
      label: t('createdByEmail'),
      source: 'journey_data',
      field: 'created_by_email',
      type: 'email',
    },
    { label: t('createdAt'), source: 'journey_data', field: 'created_at', type: 'date' },
    {
      label: t('triggeredByName'),
      source: 'journey_data',
      field: 'triggered_by_name',
      type: 'text',
    },
    {
      label: t('triggeredByEmail'),
      source: 'journey_data',
      field: 'triggered_by_email',
      type: 'email',
    },
    { label: t('currentDate'), source: 'journey_data', field: 'current_date', type: 'date' },
    { label: t('startedAt'), source: 'journey_data', field: 'started_at', type: 'date' },
    { label: t('sourceType'), source: 'journey_data', field: 'source_type', type: 'text' },
  ];
};
